/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const eligibleScheduleAgentsResponseOutputAgentsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const eligibleScheduleAgentsResponseOutputAgentsItemDisplayNameMax = 500;

export const eligibleScheduleAgentsResponseOutputAgentsItemInitialsMax = 8;

export const eligibleScheduleAgentsResponseOutputAgentsMax = 1000;

export const EligibleScheduleAgentsResponseOutput = zod.object({
  agents: zod
    .array(
      zod.object({
        id: zod.uuid().regex(eligibleScheduleAgentsResponseOutputAgentsItemIdRegExp),
        displayName: zod
          .string()
          .min(1)
          .max(eligibleScheduleAgentsResponseOutputAgentsItemDisplayNameMax),
        initials: zod
          .string()
          .min(1)
          .max(eligibleScheduleAgentsResponseOutputAgentsItemInitialsMax),
      }),
    )
    .max(eligibleScheduleAgentsResponseOutputAgentsMax),
});

export type EligibleScheduleAgentsResponseOutput = zod.input<
  typeof EligibleScheduleAgentsResponseOutput
>;
export type EligibleScheduleAgentsResponseOutputOutput = zod.output<
  typeof EligibleScheduleAgentsResponseOutput
>;
